import React from "react";
import { Field, reduxForm } from "redux-form";
import { FormGroup, Row, Col } from "react-bootstrap";
import Button from "../elements/CustomButton/CustomButton";

import { renderField } from "./_fieldRenderer";

import "./forms.css";

const validate = (values) => {
  const errors = {};
  if (!values.goal) {
    errors.goal = "Obrigatório";
  } else if (values.goal <= 0) {
    errors.goal = "Deve ser maior que zero";
  }
  return errors;
};

class GoalForm extends React.Component {
  constructor(props) {
    super(props);
    this.company = props.company;
  }

  render() {
    const { handleSubmit, submitting } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="goal"
                type="number"
                component={renderField}
                placeholder="Meta (em gramas)"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <p className="form__help">
              Ao modificar uma meta, os dados previamente incluídos pelo
              aplicativo não são alterados.
            </p>
          </Col>
        </Row>

        <Row className="form__actions_margin">
          <div className="form__actions_container">
            <Button
              style={{ width: "45%" }}
              bsStyle="danger"
              type="button"
              disabled={submitting}
              onClick={this._handleCancel}
              wd
            >
              Cancelar
            </Button>
            <Button
              style={{ width: "45%" }}
              bsStyle="default"
              type="submit"
              disabled={submitting}
              fill
            >
              Salvar
            </Button>
          </div>
        </Row>
      </form>
    );
  }

  //handlers
  _handleCancel = () => {
    this.props.reset(); //form reset - redux-form action creator
    this.props.handleCancel(); //function passed via props
  };
}

GoalForm = reduxForm({ form: "GoalForm", validate })(GoalForm);
export default GoalForm;



// WEBPACK FOOTER //
// ./src/forms/GoalForm.jsx